'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var React = require('react');
var react = require('@chakra-ui/react');
var reactHookForm = require('react-hook-form');
var Feedback = require('../Feedback/Feedback.js');
var logger = require('../../utils/logger.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["children"];
/**
 * Form error
 *
 * Automatically shows the correct error message when used within
 * `<FormControl />` (from the design system) and `<FormProvider />` (from
 * react-hook-form).
 */
var FormError = function FormError(props) {
  var _formContext$formStat;
  var children = props.children,
    rest = _objectWithoutProperties__default["default"](props, _excluded);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  var formControlContext = react.useFormControlContext();
  // eslint-disable-next-line react-hooks/rules-of-hooks
  var formContext = reactHookForm.useFormContext();
  if (!formContext && !children) logger.error('`<FormProvider /> context is missing. Did you wrap this component in `<FormProvider />`?', 'FormError');
  if (!formControlContext && !children) logger.error('`<FormControl /> context is missing. Did you wrap this component in `<FormControl />`?', 'FormError');

  // Retrieve error
  var fieldId = formControlContext === null || formControlContext === void 0 ? void 0 : formControlContext.id;
  var fieldError = formContext === null || formContext === void 0 ? void 0 : (_formContext$formStat = formContext.formState) === null || _formContext$formStat === void 0 ? void 0 : _formContext$formStat.errors[fieldId];

  // ... and get the message.
  var message = (fieldError === null || fieldError === void 0 ? void 0 : fieldError.message) && String(fieldError.message);
  return /*#__PURE__*/React__default["default"].createElement(Feedback.Feedback, _extends__default["default"]({
    mt: 1,
    display: "block",
    colorScheme: "red"
  }, rest), children || message);
};
FormError.displayName = 'FormError';
exports.FormError = FormError;